import IDCardinfo from "./IDCardinfo";
export default IDCardinfo;
